/* eslint-disable prefer-promise-reject-errors */
/* eslint-disable space-before-function-paren */
import Vue from 'vue'
import miniAuthTrigger from '@components/mini-auth-trigger'
import { getUrlParams } from '@zz-common/native-adapter/es/core/utils/util'
import { cookie, env, isEmptyData } from '@zz-yp/hunter-js-utils'
import { login } from './login'

const setCookie = function (name, value) {
  const Days = 30
  const exp = new Date()
  exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000)
  document.cookie = `${name}=${value};expires=${exp.toGMTString()};domain=.zhuanzhuan.com;path=/`
  document.cookie = `${name}=${value};expires=${exp.toGMTString()};domain=.caihuoxia.com;path=/`
}

/**
 * 在小程序中跳转到登录授权页面
 * @param {string} [href=window.location.href] - 需要跳转的 URL
 * @return {void}
 */
export const miniProgramLogin = (href = window.location.href) => {
  const newHref = encodeURIComponent(href.replace(/(\?|&)(uid|PPU|tk)=[^&]*/g, ''))
  const url = `/pages/login/index?url=${newHref}`
  window.wx.miniProgram.redirectTo({ url })
}

/**
 * 在小程序中展示登录授权弹窗，点击取消登录 resolve(false),
 * 点击登录，直接去小程序原生页面授权，不需要返回状态
 * @return {Promise<boolean>} 点击取消登录 resolve(false), 其他情况 promise 不 resolve
 */
export const handleMiniLogin = (targetUrl) => {
  return new Promise((resolve) => {
    miniAuthTrigger.install({
      onCancel: () => {
        resolve(false)
        // reject('小程序授权弹窗，取消登录！')
      },
      onConfirm: () => {
        // 点击登录，直接去小程序原生页面授权，不需要返回状态
        // resolve(true)
      },
      targetUrl
    })
  })
}

// 清除localStorage
export function clearLocalStorage() {
  window.localStorage.clear()
}

// 清除cookie
export function removeAllCookies() {
  const cookies = cookie.get()
  const cookieKeys = Object.keys(cookies)
  cookieKeys.forEach((key) => {
    if (key !== 't') {
      setCookie(key, '')
    }
  })
}

const clearLoginState = () => {
  removeAllCookies()
  clearLocalStorage()
}

/**
 * 退出微信小程序
 * @return {void}
 */
export const handleLogout = () => {
  const logoutCallback = async () => {
    // 清除cookie
    clearLoginState()
    const url = '/pages/index/index?chxLogout=true'
    window.wx.miniProgram.redirectTo({ url })
  }
  Vue.prototype.$dialog
    .confirm({
      title: '温馨提示',
      cancelButtonText: '确认退出账号',
      confirmButtonText: '取消',
      business: true,
      message:
        '退出当前账号会将您的微信与当前采货侠账号解绑，之后您可用手机号授权登录，请再次确认是否要退出账号'
    })
    .then(() => {
      // 设计按钮，反向操作
      console.log('取消退出账号')
    })
    .catch(logoutCallback)
}

/**
 * 小程序环境下，登录拦截
 * @returns {Promise<boolean>} 是否登录成功「true： 其他环境｜正在审核中」
 */
export const miniInterceptor = async (targetUrl) => {
  // 小程序环境下
  // 还有一个逻辑如果地址栏没有ppu,走下方逻辑
  if (env.$isMiniprogram) {
    const loginRes = await handleMiniLogin(targetUrl) // 拦截登录
    return loginRes
  }
  return true
}

export const toastLog = (msg) => Vue.prototype.$toast(msg)

export const initWxCookie = () => {
  if (env.$isMiniprogram) {
    const { PPU } = getUrlParams() || {}
    let ppu = PPU ? decodeURIComponent(PPU) : ''
    if (ppu && !/^['|"]/.test(ppu)) {
      ppu = `"${ppu}"`
    }
    setCookie('PPU', ppu)
    setCookie('ZZU', ppu)
    setCookie('Safe-PPU', ppu)
  }
}

/**
 * @description: 检查当前登录状态
 * @param {Object} ops 传入参数
 * @param {boolean} [ops.hunterLoginCheck=false] 是否需要进行授权登录拦截
 * @return {Promise<boolean>} 是否登录成功
 */
export const checkHunterLoginStatus = async (ops) => {
  // 1、检查cookie，是否登录
  if (!isEmptyData(cookie.getPPU())) return true

  // 2、跳转前，是否走前置校验拦截
  const { hunterLoginCheck = false } = ops || {}
  if (!hunterLoginCheck) return true

  // 3、小程序环境下，授权登录拦截
  const interceptRes = await miniInterceptor()
  if (!interceptRes) return false // mini 取消登录

  // 4、端上｜h5，唤起登录
  const res = await login()
  return res && res.code == 0
}
